<template>
    <div v-if="currentPage && currentPage.acf" class="single-event-meta jost jost--25 font--400">
        <div v-if="currentPage.acf.event_date" class="event-date">{{ dateFormatted }}</div>
        <div v-if="currentPage.acf.event_date_end && currentPage.acf.event_date !== currentPage.acf.event_date_end" class="event-date-end">til {{ dateFormattedEnd }}</div>
        <div v-else class="time-frame">
            <span class="kl">kl</span> <span v-if="currentPage.acf.start_time" class="event-start-time">{{ currentPage.acf.start_time.slice(0,5) }}</span>
            <span v-if="currentPage.acf.end_time" class="event-end-time"> - {{ currentPage.acf.end_time.slice(0,5) }}</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment  from 'moment' 
moment.locale('nb');    

export default {
    name: 'single-event-meta',
     computed: {
        ...mapGetters([
            'currentPage',
            'currentPostType',
        ]),
        dateFormattedEnd(){
            return this.currentPage.acf.event_date_end ? moment(this.currentPage.acf.event_date_end).format('dddd DD. MMMM YYYY') : false
		},
        dateFormatted(){
            // we need to add time because it will be set to 00:00 and due to time change date will be off
            return moment(this.currentPage.acf.event_date).format('dddd DD. MMMM YYYY')
            
        }
    },
}
</script>

<style lang="scss">
.single-event-meta{
    .event-date{
        &::first-letter{
            text-transform: capitalize;
        }
    }
}
</style>